import { TenantFormattingService } from '../../../core/services/tenant-formatting.service';
import { AppDatePipe } from '../../pipes/app-date.pipe';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { firstValueFrom, Subscription } from 'rxjs';
import { AppNotification, CommunicationService } from '../../../core/services/communication.service';
import { notificationOrderQueryParams } from '../../../core/models/communication.model';
import { communicationLimits } from '../../../core/config/communication.config';
@Component({
  selector: 'app-notification-center',
  imports: [AppDatePipe, RouterLink, FaIconComponent],
  templateUrl: './notification-center.html',
  styleUrl: './notification-center.css',
  host: { '[class.mobile]': 'mobile' }
})
export class NotificationCenterComponent implements AfterViewInit, OnDestroy {
  readonly orderQueryParams = notificationOrderQueryParams;
  readonly formatting = inject(TenantFormattingService);
  @Input()
  mobile = false;
  readonly faBell = faBell;
  items: AppNotification[] = [];
  loading = false;
  error = false;
  markingAll = false;
  readError = false;
  private opened = false;
  private destroyed = false;
  private refreshQueued = false;
  private request?: Subscription;
  private changes?: Subscription;
  private readonly show = () => { this.opened = true; this.load(); };
  private readonly hide = () => { this.opened = false; this.refreshQueued = false; };
  constructor(public communication: CommunicationService, private element: ElementRef<HTMLElement>) { }
  ngAfterViewInit(): void {
    this.element.nativeElement.addEventListener('show.bs.dropdown', this.show);
    this.element.nativeElement.addEventListener('hide.bs.dropdown', this.hide);
    this.changes = this.communication.changes.subscribe(() => {
      if (!this.opened)
        return;
      if (this.loading)
        this.refreshQueued = true;
      else
        this.load();
    });
  }
  ngOnDestroy(): void {
    this.destroyed = true;
    this.request?.unsubscribe();
    this.changes?.unsubscribe();
    this.element.nativeElement.removeEventListener('show.bs.dropdown', this.show);
    this.element.nativeElement.removeEventListener('hide.bs.dropdown', this.hide);
  }
  load(): void {
    if (this.destroyed)
      return;
    this.request?.unsubscribe();
    this.refreshQueued = false;
    this.loading = true;
    this.error = false;
    const request = new Subscription();
    this.request = request;
    request.add(this.communication.inbox().subscribe({
      next: page => {
        if (!this.refreshQueued)
          this.items = page.items.slice(0, communicationLimits.notificationPreviewSize);
        this.finishLoad();
      },
      error: () => { this.error = true; this.finishLoad(); }
    }));
  }
  private finishLoad(): void {
    this.loading = false;
    if (this.refreshQueued && this.opened)
      this.load();
  }
  markRead(item: AppNotification): void {
    if (item.isRead)
      return;
    // Keep the receipt alive when following a link destroys the layout.
    void firstValueFrom(this.communication.read([item.id]))
      .then(() => this.communication.refreshUnread()).catch(() => { });
  }
  async markAllRead(): Promise<void> {
    if (this.markingAll)
      return;
    this.markingAll = true;
    this.readError = false;
    try {
      await firstValueFrom(this.communication.readAll());
      this.communication.refreshUnread();
      this.load();
    }
    catch {
      this.readError = true;
    }
    finally {
      this.markingAll = false;
    }
  }
}
